// 用户管理
export default {
    userName: '用户名称',
    name: '姓名',
    role: '角色',
    mobileNumberQuery: '手机号码查询',
    pleaseChoose: '请选择',
    cellphoneNumber: '手机号码',
    licenseType: '执照类型',
    department: '部门',
    addUser: '添加用户',
    editUser: '编辑用户',
    pilotCertification: '飞手认证',
    pendingCertification: '待认证',
    fail: '不通过',
    check: '查看',
    certificationInformation: '认证信息',
    passThrough: '通过',
    remark: '备注',
    verified: '已认证',
    notCertified: '未认证',
    freeze: '冻结',
    certification: '认证',
    certificationResult: '认证结果',
    userAccount: '用户账户',
    pleaseEnter: '请输入',
    contactInformation: '联系方式',
    isDepartment: '所在部门',
    userRole: '用户角色',
    passwordSetting: '密码设置',
    operate: '操作',
    enterPassword: '请输入密码',
    changePassword: '密码修改',
    userAddSuccessfully: '用户添加成功',
    userEditSuccessfully: '用户编辑成功',
    loginPassword: '登录密码',
    copyAccountPwd: '复制账号密码',
    personalInfoAuthentication: '个人信息认证',
    verifieds: '实名认证',
    actualName: '真实姓名',
    idNumber: '身份证号',
    idPhoto: '身份证人像面照片',
    addidfacephoto: '添加身份证人像面照片',
    ptneotIDc: '身份证国徽面照片',
    addptneotIDc: '添加身份证国徽面照片',
    authenticationType: '认证类型',
    model: '机型',
    grade: '等级',
    IDPhoto: '证件人像面照片',
    addIDPhoto: '添加证件人像面照片',
    potrsotd: '证件反面照片',
    addpotrsotd: '添加证件反面照片',
    upload: '上传',
    mobileFormatError: '手机号格式错误',
    idNumberFormatError: '身份证号格式错误',
    addressEncodingError: '地址编码错误',
    CheckDigitError: '校验位错误',
    automaticGenerated: '自动生成',
    manualEntry: '手动输入',
    allow: '允许',
    prohibit: '禁止',
    pleaseEnterUsername: '请输入用户名称',
    pleaseEnterDept: '请选择部门',
    pleaseEnterUserAccount: '请输入用户账户',
    pleaseSelectUserRole: '请选择用户角色',
    pleaseSelectPasswordSetting: '请选择密码设置',
    pleaseEnterYourRealName: '请输入真实姓名',
    plidentificationNumber: '请输入身份证号',
    PeCorrectIDNumber: '请输入正确的证件号',
    pUploadIdPhoto: '请上传身份证人像面照片',
    uploadIdCardEm: '请上传身份证国徽面照片',
    selectAuthenticationType: '请选择认证类型',
    pleaseSelectModel: '请选择机型',
    pleaseSelectLevel: '请选择等级',
    uploadPassportPhoto: '请上传证件人像面照片',
    uploadPhotoBackYourXId: '请上传证件反面照片',
    copySuccessfully: '复制成功',
    replicationFailed: '复制失败',
    uploadImgFormatWrong: '上传图片格式错误',
    confirmWhetherRestore: '请确认是否恢复',
    recover: '恢复',
    successfulOperation: '操作成功!',
    delUserTip: '用户被删除后，将无法恢复，请谨慎操作！',
    frozenTip: '注意！用户被冻结后无法登录系统，但仍保留用户数据！',
    editSuccessTip:'修改成功，再次登录后生效。'
}
